
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { useState } from 'react';
import { Collapsible, Icon, Shade, Button, Size, Category } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';
export const ControlledField = ({
  component: Component
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div style={{
    maxWidth: 400
  }}>
      {React.cloneElement(Component, {
      isOpen,
      onClick: () => setIsOpen(!isOpen)
    })}
    </div>;
};

const layoutProps = {
  ControlledField
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Collapsible`}</h1>
<p>{`This component is used when there is a lot of information on the page, and we want to declutter the UI. This component is `}<strong parentName="p">{`controlled`}</strong>{`.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Collapsible } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>

<Playground __position={0} __code={`<ControlledField component={
  <Collapsible title="Some information">
    <div style={{ background: 'red', height: 150 }} />
  </Collapsible>
} />`} component={Collapsible} mdxType="Playground">
  <ControlledField component={<Collapsible title="Some information" mdxType="Collapsible">
      <div style={{
          background: 'red',
          height: 150
        }} />
    </Collapsible>} mdxType="ControlledField" />
</Playground>
<h2>{`With leading and trailing`}</h2>
<Playground __position={1} __code={`<ControlledField component={
  <Collapsible
    title="Some information"
    leading={<Icon name="globe" shade={Shade.LIGHT} />}
    trailing={
      <Button leading={<Icon name="trash" />} category={Category.DANGER} size={Size.SMALL} />
    }>
    <div style={{ background: 'red', height: 150 }} />
  </Collapsible>
} />`} mdxType="Playground">
  <ControlledField component={<Collapsible title="Some information" leading={<Icon name="globe" shade={Shade.LIGHT} mdxType="Icon" />} trailing={<Button leading={<Icon name="trash" mdxType="Icon" />} category={Category.DANGER} size={Size.SMALL} mdxType="Button" />} mdxType="Collapsible">
      <div style={{
          background: 'red',
          height: 150
        }} />
    </Collapsible>} mdxType="ControlledField" />
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;